import { useState, useCallback } from 'react';
import { Notification as NotificationComponent } from '@/components/common/Notification';

type NotificationType = 'success' | 'error' | 'warning' | 'info';

interface NotificationState {
  message: string;
  type: NotificationType;
  id: number;
}

export const useNotification = () => {
  const [notifications, setNotifications] = useState<NotificationState[]>([]);

  const showNotification = useCallback(
    (message: string, type: NotificationType = 'info') => {
      const id = Date.now();
      setNotifications((prev) => [...prev, { message, type, id }]);
    },
    []
  );

  const removeNotification = useCallback((id: number) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const NotificationContainer = () => (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {notifications.map((notification) => (
        <NotificationComponent
          key={notification.id}
          message={notification.message}
          type={notification.type}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  );

  return {
    showNotification,
    NotificationContainer,
  };
};

